import { signOut } from "aws-amplify/auth";
import { useQueryClient } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import useDeflowSessionStore from "@/stores/useDeflowSessionStore";

export const Route = createFileRoute("/_authenticated/sign-out")({
  component: SignOut,
});

function SignOut() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    void (async () => {
      try {
        await signOut({ global: true });
      } catch {
        // ignore duplicate sign-outs
      }
      useDeflowSessionStore.getState().setNotAuthenticated();
      queryClient.clear();
      navigate({ to: "/sign-in", replace: true });
    })();
  }, [navigate, queryClient]);

  return (
    <main className="flex items-center justify-center h-[60vh]">
      <img src="/deflow.png" alt="Deflow logo" width={180} height={37} />
    </main>
  );
}
